import { t } from '../i18n';

export type EmptyKind = 'no-code' | 'not-found' | 'error';

export function EmptyState({ kind, message }: { kind: EmptyKind; message?: string }) {
  return (
    <main class="min-h-dvh flex items-center justify-center bg-background p-6 text-center">
      <div class="max-w-sm space-y-4">
        {/* Official app icon — self-contained navy mark, shown rounded like the
            home-screen icon. Brand name is locale-driven (KommGutHeim / ArriveSafe). */}
        <img
          src="/app-icon.png"
          alt={t('brand')}
          class="mx-auto h-20 w-20 rounded-2xl shadow-lg select-none"
          draggable={false}
        />
        <h1 class="text-lg font-semibold text-primary">{t('brand')}</h1>
        <p class="text-sm text-text-secondary">
          {kind === 'no-code' && t('empty.noCode', { url: 'way.arrivesafe.app/<CODE>' })}
          {kind === 'not-found' && t('empty.notFound')}
          {kind === 'error' && t('empty.error', { message: message ?? '—' })}
        </p>
      </div>
    </main>
  );
}
